import React from "react";
import PublicPage from "../../components/layout/PublicPage";

export default function Error({ title, message }) {
  return (
    <PublicPage title={title}>
      <div className="container">
        <div
          className="card border-danger mt-5"
          style={{ maxWidth: "500px", margin: "auto", border: "1px solid" }}
        >
          <div className="card-body">
            <h1>
              <i className="fa-solid fa-circle-exclamation me-4"></i>
              {title}
            </h1>
            {message && <p>{message}</p>}
          </div>
        </div>
      </div>
    </PublicPage>
  );
}
